/**
 * Overview on a phone (screenshots/55, phone 3 "Good morning"): the greeting, the dark Next card, Since your last visit
 * as tappable rows, and the How would you vote? card with 44px buttons. The desktop grid isn't shown below 768px
 * (mobile.css); customize mode is desktop-only.
 */
import { useState } from "react";
import { navigate, plainClick } from "../app/router";
import { OvIcon } from "./icons";
import { useOverview } from "./overviewStore";
import { OvChip } from "./widgets/parts";

export function MobileOverview({ hello }: { hello: string }) {
  const feeds = useOverview((s) => s.feeds);
  const v = feeds.nextVote, a = feeds.yourAlderperson, since = feeds.sinceLastVisit?.lines ?? [];
  // The first item on the next agenda you follow (55): your saved position is kept; a new tap is outlined.
  const ask = feeds.howWouldYouVote?.items[0] ?? null;
  const [chosen, setChosen] = useState<"support" | "oppose" | null>(ask?.stance ?? null);
  const [touched, setTouched] = useState(false);
  const choose = (pos: "support" | "oppose") => {
    if (!ask) return;
    const next = chosen === pos ? null : pos;
    setChosen(next);
    setTouched(true);
    void fetch(`/api/dashboard/legislation/${encodeURIComponent(ask.recordId)}/stance`, { method: next ? "PUT" : "DELETE", credentials: "include",
      headers: { "content-type": "application/json" }, body: JSON.stringify({ position: next }) }).catch(() => {});
  };
  return (
    <div className="ov-mobile">
      <h1 className="ov-mobile__hello">{hello}</h1>
      {v && (
        <a className="ov-mobile__next" href={v.meetingId ? `/dashboard/meetings/${v.meetingId}` : "/dashboard/meetings"}
          onClick={(e) => { if (!plainClick(e)) return; e.preventDefault(); navigate(v.meetingId ? `/dashboard/meetings/${v.meetingId}` : "/dashboard/meetings"); }}>
          <span className="ov-mobile__k">Next · {v.body} · {v.dateLong.replace(",", "").replace(":00", "")}</span>
          <span className="ov-mobile__t">{v.yourItems} item{v.yourItems === 1 ? "" : "s"} you follow {v.yourItems === 1 ? "is" : "are"} up for a vote</span>
          {a?.summaryShort && <span className="ov-mobile__s">Ald. {a.name.split(" ").slice(-1)[0]}: {a.summaryShort}</span>}
        </a>
      )}
      {since.length > 0 && <h2 className="ov-mobile__label">Since your last visit</h2>}
      {since.map((l, n) => (
        <a key={n} className="ov-mobile__row" href={l.href ?? "/dashboard/meetings"} onClick={(e) => { if (!plainClick(e)) return; e.preventDefault(); navigate(l.href ?? "/dashboard/meetings"); }}>
          <OvChip chip={{ text: l.tag, tone: l.tone }} />
          <span>{l.short ?? l.text}</span>
          <OvIcon name="chevron-right" size={16} />
        </a>
      ))}
      {ask && (
        <section className="ov-mobile__weigh" aria-label="How would you vote?">
          <h2>How would you vote on the {ask.title.charAt(0).toLowerCase() + ask.title.slice(1)}?</h2>
          <div className={`ov-mobile__btns${touched ? " is-touched" : ""}`} role="radiogroup" aria-label={ask.title}>
            <button role="radio" aria-checked={chosen === "support"} className="is-primary" onClick={() => choose("support")}><OvIcon name="thumbs-up" />Support</button>
            <button role="radio" aria-checked={chosen === "oppose"} onClick={() => choose("oppose")}><OvIcon name="thumbs-down" />Oppose</button>
          </div>
        </section>
      )}
    </div>
  );
}
